var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayMarket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2425_8418)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.898 10.9757C17.5844 7.44387 11.2716 3.91064 4.95962 0.375996C4.33568 -0.0360661 3.61781 -0.0900661 2.99756 0.119871L18.8757 15.998L23.898 10.9757Z",
    fill: "#32BBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.99749 0.121094C2.88124 0.160469 2.76812 0.207969 2.65993 0.265344C1.97499 0.635844 1.47168 1.34878 1.47168 2.25047V29.748C1.47168 30.6497 1.97493 31.3626 2.65993 31.733C2.76831 31.7901 2.88106 31.8385 2.99712 31.8777L18.8756 15.9992L2.99749 0.121094Z",
    fill: "#32BBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8756 16L2.99707 31.8784C3.61751 32.0899 4.33538 32.0401 4.95951 31.622C13.9344 26.5964 19.8336 23.2973 23.594 21.2004L23.9026 21.0271L18.8756 16Z",
    fill: "#32BBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.47168 16V29.7487C1.47168 30.6504 1.97493 31.3634 2.65993 31.7338C2.76831 31.7909 2.88106 31.8392 2.99712 31.8784L18.8756 16H1.47168Z",
    fill: "#2C9FD9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.95978 0.376744C4.21884 -0.112506 3.34509 -0.0985682 2.66016 0.264932L18.6348 16.2397L23.8981 10.9764C17.5845 7.4446 11.2718 3.91137 4.95978 0.376744Z",
    fill: "#29CC5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.635 15.7578L2.66016 31.7325C3.34516 32.0959 4.21884 32.1169 4.95978 31.6207C13.9347 26.5951 19.8339 23.2959 23.5943 21.1991L23.9029 21.0258L18.635 15.7578Z",
    fill: "#D93F21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5282 15.9979C30.5282 15.236 30.1438 14.4672 29.3819 14.0408C29.3819 14.0408 27.9569 13.2457 23.5892 10.8027L18.394 15.9979L23.5943 21.1982C27.914 18.7728 29.3818 17.955 29.3818 17.955C30.1438 17.5287 30.5282 16.7598 30.5282 15.9979Z",
    fill: "#FFD500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3819 17.9571C30.1438 17.5308 30.5282 16.7619 30.5282 16H18.394L23.5943 21.2003C27.9141 18.7749 29.3819 17.9571 29.3819 17.9571Z",
    fill: "#FFAA00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2425_8418"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayMarket);
export default __webpack_public_path__ + "static/media/play-market.7a4878ed7c9733b39c82d22f16286228.svg";
export { ForwardRef as ReactComponent };